import PropTypes from 'prop-types';
import React from 'react';
import EditModal from '../../common/modal/EditModal';
import RowDisplay from '../../common/RowDisplay';
import SSNForm from './SSNForm';
function SSNDisplay(props) {
  var contact = props.contact;
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Social Security Number",
    size: "normal",
    formName: "edit-ssn",
    editButtonId: "edit-ssn-btn",
    id: "edit-ssn-modal"
  }, /*#__PURE__*/React.createElement(SSNForm, {
    contact: contact
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "SSN"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "profile-value"
  }, "*** - ** - ****")));
}
SSNDisplay.propTypes = {
  contact: PropTypes.object.isRequired
};
export default SSNDisplay;
//# sourceMappingURL=SSNDisplay.js.map